import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- // 
import { LocalSEO } from 'components/blocks/portfolio'; 
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'The Tree Company Sussex',
  categories: 'seo, web design',
  description:
    'The Tree Company Sussex is a tree surgery company in Sussex that provides professional and reliable tree services to residential and commercial customers. They approached us to design and develop a new website and provide SEO services to improve their online visibility and reach a wider audience.',
  parentDirectories: 'seo-design-portfolio'
};
const Portfolio = All.LocalSEOArrays[1].keywords;

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}
      {' '}
      <main className="content-wrapper">
        {/* ========== SEO META values ========== */}

        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
          urlENPT={``}
          url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />

        {/* ========== heading section ========== */}
        <section
          className="wrapper image-wrapper bg-image bg-overlay text-white"
          style={{
            backgroundImage: 'url(/img/clients/' + Portfolio[1].title.toLowerCase().replace(/ /g, '-') + '-bg.jpg)',
            backgroundSize: 'cover'
          }}
        >
          <div className="container pt-17 pb-12 pt-md-19 pb-md-16 text-center">
            <div className="row">
              <div className="col-md-10 mx-auto">
                <div className="post-header">
                  {/* <div className="post-category text-line text-white">
                    <NextLink title="Identity" href="#" className="text-reset" />
                  </div> */}
                  <h1 className="fs-15 text-uppercase text-white mb-3">{Portfolio[0].title}</h1>
                  <p className="display-4 text-capitalize mx-auto">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper bg-light wrapper-border">
          {/* ========== details section ========== */}
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className="display-6 mb-4">{details.pageName}</h2>

                <div className="row">
                  <div className="col-md-8 text-justify">
                    <p style={{ clear: 'right' }}>
                      {/* <NextLinkNoAlt href={keywords[0].url} title={keywords[0].title} /> */}
                      {/* <br /> */}{' '}
                      <img
                        width={120}
                        height={'auto'}
                        src={`/img/${All.localSEOPackages[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                        alt={All.localSEOPackages[1].title}
                        style={{ background: 'transparent', float: 'right' }}
                        className="mb-5 ms-3"
                        // align="right"
                      />
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <p style={{ clear: 'right' }}>
                      Our team at SEOptimist  <NextLink title={All.HomeList[1].title} href="/" /> began by conducting thorough
                      research on their industry and competitors to understand their target audience and identify
                      high-value keywords. We then worked with the client to create a custom WordPress website that
                      accurately reflected their brand and showcased their services.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-4 mw"
                    />
                    <p>
                      We optimized the website's structure, content, and metadata to ensure that it was search engine
                      friendly and fully aligned with their SEO strategy. Our team also implemented technical SEO
                      optimizations, such as website speed optimization and mobile responsiveness, to improve user
                      experience and website performance.
                    </p>
                    <p>
                      To achieve a strong online presence for The Tree Company Sussex, we implemented a strategic SEO
                      campaign that included on-page optimization, link building, and content marketing. Our team
                      consistently produced high-quality content that was both informative and engaging, showcasing the
                      client's expertise and experience in the tree surgery industry.
                    </p>
                    <p>
                      As a result of our efforts, The Tree Company Sussex has achieved impressive results in a highly
                      competitive market. They are now ranking number one for their highly competitive search terms and
                      have seen a significant increase in website traffic, leads, and conversions. They have also
                      received positive feedback from their customers, who have praised the website's design,
                      functionality, and ease of use.
                    </p>
                    <p>
                      At SEOptimist  <NextLink title={All.HomeList[3].title} href="/" />, we take pride in delivering
                      customized SEO solutions that meet our clients' unique needs. Our results-driven approach ensures
                      that we deliver measurable results and a strong return on investment. If you're looking to improve
                      your online visibility and reach a wider audience, contact us today to learn more about our SEO
                      services.
                    </p>{' '}
                  </div>

                  <div className="col-md-4 ms-auto">
                    <img
                      width={275}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[1].title}
                      style={{ background: 'transparent' }}
                      className="mb-4 mw"
                    />
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                  <NextLink title="Get in touch" href="/#contact" className="more hover" />
                  {/* ========== portfolio section ========== */}
                  <LocalSEO initialslide={3} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ========== navigation section ========== */}
        <ProjectDetailsNavigation />
        </main>

        <ContactFooterCombo location="brighton" />
    </Fragment>
  );
};

export default ProjectDetails;
